import { render, staticRenderFns } from "./GoToBack.vue?vue&type=template&id=2def5cd0"
import script from "./GoToBack.vue?vue&type=script&lang=js"
export * from "./GoToBack.vue?vue&type=script&lang=js"
import style0 from "./GoToBack.vue?vue&type=style&index=0&id=2def5cd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports